import React from 'react'

import { Text } from 'elements/text/Text'
import { Alert } from 'elements/ui/Alert'

import { ICON } from 'config/icons'

import { COMMUNITY_PUBLICATION_FREQUENCY } from 'modules/community/constants'
import { isNovenaOrRetreat } from 'modules/community/functions'
import { useCommunityFrequency } from 'modules/community/hooks/useCommunityFrequency'
import type { TCommunity } from 'modules/community/types'

export type TCommunityFrequencyAlertProps = {
  community: TCommunity
}

export const CommunityFrequencyAlert: TFC<TCommunityFrequencyAlertProps> = ({ community }) => {
  const { frequencyType, frequencyText } = useCommunityFrequency({ community })
  if (isNovenaOrRetreat(community)) return null

  return (
    frequencyType !== COMMUNITY_PUBLICATION_FREQUENCY.UNKNOWN && (
      <Alert icon={ICON.CALENDAR} status="transparent" hideCloseButton>
        <Text lowercase firstUpper>
          {frequencyText}
        </Text>
      </Alert>
    )
  )
}
